<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'
  import Vol01 from './Vol01.vue'
  import Vol02 from './Vol02.vue'
  import Vol03 from './Vol03.vue'
  import Vol04 from './Vol04.vue'
  import Vol05 from './Vol05.vue'
  import Vol06 from './Vol06.vue'
  import Jewel01 from './Jewel01.vue'
  import Jewel02 from './Jewel02.vue'
  import Jewel03 from './Jewel03.vue'
  import Jewel04 from './Jewel04.vue'
  import Jewel05 from './Jewel05.vue'
  import Jewel06 from './Jewel06.vue'
  import PriTama01 from './PriTama01.vue'
  import PriTama02 from './PriTama02.vue'
  import PriTama03 from './PriTama03.vue'
  import PriTama04 from './PriTama04.vue'
  import PriTama05 from './PriTama05.vue'
  import PriTama06 from './PriTama06.vue'


  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */
  /** @type {ItemInfo[]} */ const itemsVol01 = Vol01.data().items
  /** @type {ItemInfo[]} */ const itemsVol02 = Vol02.data().items
  /** @type {ItemInfo[]} */ const itemsVol03 = Vol03.data().items
  /** @type {ItemInfo[]} */ const itemsVol04 = Vol04.data().items
  /** @type {ItemInfo[]} */ const itemsVol05 = Vol05.data().items
  /** @type {ItemInfo[]} */ const itemsVol06 = Vol06.data().items
  /** @type {ItemInfo[]} */ const itemsJewel01 = Jewel01.data().items
  /** @type {ItemInfo[]} */ const itemsJewel02 = Jewel02.data().items
  /** @type {ItemInfo[]} */ const itemsJewel03 = Jewel03.data().items
  /** @type {ItemInfo[]} */ const itemsJewel04 = Jewel04.data().items
  /** @type {ItemInfo[]} */ const itemsJewel05 = Jewel05.data().items
  /** @type {ItemInfo[]} */ const itemsJewel06 = Jewel06.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama01 = PriTama01.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama02 = PriTama02.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama03 = PriTama03.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama04 = PriTama04.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama05 = PriTama05.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama06 = PriTama06.data().items


  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2022-03-22',
        items: [

          // [NOTE] プリリズADチャンネル ER
          // ================================================================================

          item({
            collection  : 'PRADCh',
            id          : 'PAF01-01',
            rare        : 'ER',
            name        : 'ピュアホワイトウエディング',
            imgUrl      : '/images/items/PAF01-01.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-02',
            rare        : 'ER',
            name        : 'ピュアクリスタルハイヒール',
            imgUrl      : '/images/items/PAF01-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PRADCh',
            id          : 'PAF01-03',
            rare        : 'ER',
            name        : 'ピュアプレミアムウエディング',
            imgUrl      : '/images/items/PAF01-03.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-04',
            rare        : 'ER',
            name        : 'ピュアプレミアムハイヒール',
            imgUrl      : '/images/items/PAF01-04.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PRADCh',
            id          : 'PAF01-05',
            rare        : 'ER',
            name        : 'ピュアフレッシュウエディング',
            imgUrl      : '/images/items/PAF01-05.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-06',
            rare        : 'ER',
            name        : 'ピュアフレッシュハイヒール',
            imgUrl      : '/images/items/PAF01-06.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            rare        : 'ER',
          }),
          item({
            collection  : 'PRADCh',
            rare        : 'ER',
          }),


          // [NOTE] プリリズADチャンネル PR
          // ================================================================================

          item({
            collection  : 'PRADCh',
            id          : 'PAF01-07',
            rare        : 'PR',
            name        : 'シャイニーリボンベスト',
            imgUrl      : '/images/items/PAF01-07.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-08',
            rare        : 'PR',
            name        : 'シャイニーリボンスカート',
            imgUrl      : '/images/items/PAF01-08.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PRADCh',
            id          : 'PAF01-09',
            rare        : 'PR',
            name        : 'シャイニースターベスト',
            imgUrl      : '/images/items/PAF01-09.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-10',
            rare        : 'PR',
            name        : 'シャイニースターショートパンツ',
            imgUrl      : '/images/items/PAF01-10.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PRADCh',
            id          : 'PAF01-11',
            rare        : 'PR',
            name        : 'シャイニーリボンベスト',
            imgUrl      : '/images/items/PAF01-11.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-12',
            rare        : 'PR',
            name        : 'パイピングミニスカート',
            imgUrl      : '/images/items/PAF01-12.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-13',
            rare        : 'PR',
            name        : 'ラインリボンロングブーツ',
            imgUrl      : '/images/items/PAF01-13.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRADCh',
            rare        : 'PR',
          }),


          // [NOTE] プリリズADチャンネル SR
          // ================================================================================

          item({
            collection  : 'PRADCh',
            id          : 'PAF01-14',
            rare        : 'SR',
            name        : 'デビジェルミックスワンピ',
            imgUrl      : '/images/items/PAF01-14.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-15',
            rare        : 'SR',
            name        : 'デビジェルシューズ',
            imgUrl      : '/images/items/PAF01-15.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PRADCh',
            id          : 'PAF01-16',
            rare        : 'SR',
            name        : 'ゴシックデビルワンピ',
            imgUrl      : '/images/items/PAF01-16.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-17',
            rare        : 'SR',
            name        : 'デビルロングブーツ',
            imgUrl      : '/images/items/PAF01-17.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PRADCh',
            id          : 'PAF01-18',
            rare        : 'SR',
            name        : 'メルティーエンジェルワンピ',
            imgUrl      : '/images/items/PAF01-18.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-19',
            rare        : 'SR',
            name        : 'クラシックタイツ&エナメルパンプス',
            imgUrl      : '/images/items/PAF01-19.png',
            kind        : 'パンプス',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            rare        : 'SR',
          }),
          item({
            collection  : 'PRADCh',
            rare        : 'SR',
          }),


          // [NOTE] プリリズADチャンネル R
          // ================================================================================

          item({
            collection  : 'PRADCh',
            id          : 'PAF01-20',
            rare        : 'R',
            name        : 'リボンクールTシャツ',
            imgUrl      : '/images/items/PAF01-20.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-21',
            rare        : 'R',
            name        : 'ダルメシアンショートパンツ',
            imgUrl      : '/images/items/PAF01-21.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-22',
            rare        : 'R',
            name        : 'ほしがらレギンス&エナメルパンプス',
            imgUrl      : '/images/items/PAF01-22.png',
            kind        : 'パンプス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            rare        : 'R',
          }),


          item({
            collection  : 'PRADCh',
            id          : 'PAF01-23',
            rare        : 'R',
            name        : 'ポップンロケットパーカ',
            imgUrl      : '/images/items/PAF01-23.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-24',
            rare        : 'R',
            name        : 'シンプルデニムミニスカ',
            imgUrl      : '/images/items/PB-46.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-25',
            rare        : 'R',
            name        : 'ドットソックス&チェックパンプス',
            imgUrl      : '/images/items/PAF01-25.png',
            kind        : 'パンプス',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            rare        : 'R',
          }),


          item({
            collection  : 'PRADCh',
            id          : 'PAF01-26',
            rare        : 'R',
            name        : 'プリズムスクールニット',
            imgUrl      : '/images/items/PAF01-26.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-27',
            rare        : 'R',
            name        : 'プリズムスクールチェックスカート',
            imgUrl      : '/images/items/PAF01-27.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-28',
            rare        : 'R',
            name        : 'プリズムスクールローファー',
            imgUrl      : '/images/items/PB-110.png',
            kind        : 'ボトムス',
            color       : '茶',
            brand       : '',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRADCh',
            rare        : 'R',
          }),


          item({
            collection  : 'PRADCh',
            id          : 'PAF01-29',
            rare        : 'R',
            name        : 'マニッシュベスト',
            imgUrl      : '/images/items/PAF01-29.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-30',
            rare        : 'R',
            name        : 'フリフリギンガムチェックスカート',
            imgUrl      : '/images/items/PAF01-30.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-31',
            rare        : 'R',
            name        : 'モノクロタイツ&ポンポンブーツ',
            imgUrl      : '/images/items/PAF01-31.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            rare        : 'R',
          }),


          item({
            collection  : 'PRADCh',
            id          : 'PAF01-32',
            rare        : 'R',
            name        : 'バトポンワンピピンクver.',
            imgUrl      : '/images/items/PAF01-32.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-33',
            rare        : 'R',
            name        : 'バトポンスニーカーピンクver.',
            imgUrl      : '/images/items/PAF01-33.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PRADCh',
            id          : 'PAF01-34',
            rare        : 'R',
            name        : 'バトポンワンピブルーver.',
            imgUrl      : '/images/items/PAF01-34.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 1000,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-35',
            rare        : 'R',
            name        : 'バトポンスニーカーブルーver.',
            imgUrl      : '/images/items/PAF01-35.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PRADCh',
            id          : 'PAF01-36',
            rare        : 'R',
            name        : 'バトポンワンピパープルver.',
            imgUrl      : '/images/items/PAF01-36.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 1000,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            id          : 'PAF01-37',
            rare        : 'R',
            name        : 'バトポンスニーカーパープルver.',
            imgUrl      : '/images/items/PAF01-37.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PRADCh',
            rare        : 'R',
          }),
          item({
            collection  : 'PRADCh',
            rare        : 'R',
          }),


          // [NOTE] プリズムボイスチャンネル ER
          // ================================================================================

          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-38',
            rare        : 'ER',
            name        : 'パラダイスドレス',
            imgUrl      : '/images/items/PAF01-38.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-39',
            rare        : 'ER',
            name        : 'パラダイスシューズ',
            imgUrl      : '/images/items/PAF01-39.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-40',
            rare        : 'ER',
            name        : 'パラダイスティアラ',
            imgUrl      : '/images/items/PAF01-40.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-41',
            rare        : 'ER',
            name        : 'パラダイスリボンヘアアクセ',
            imgUrl      : '/images/items/PAF01-41.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-42',
            rare        : 'ER',
            name        : 'パラダイスハットヘアアクセ',
            imgUrl      : '/images/items/PAF01-42.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-43',
            rare        : 'ER',
            name        : 'パラダイスフェザーヘアアクセ',
            imgUrl      : '/images/items/PAF01-43.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-44',
            rare        : 'ER',
            name        : 'パラダイススターヘアアクセD',
            imgUrl      : '/images/items/PAF01-44.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-45',
            rare        : 'ER',
            name        : 'パラダイススターヘアアクセR',
            imgUrl      : '/images/items/PAF01-45.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリズムボイスチャンネル PR
          // ================================================================================

          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-46',
            rare        : 'PR',
            name        : 'ウィッシュリボンアイドルブラウスL',
            imgUrl      : '/images/items/PAF01-46.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-47',
            rare        : 'PR',
            name        : 'ウィッシュリボンアイドルスカートL',
            imgUrl      : '/images/items/PAF01-47.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-48',
            rare        : 'PR',
            name        : 'ウィッシュリボンアイドルブーツL',
            imgUrl      : '/images/items/PAF01-48.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-49',
            rare        : 'PR',
            name        : 'ウィッシュリボンアイドルヘアアクセL',
            imgUrl      : '/images/items/PAF01-49.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-50',
            rare        : 'PR',
            name        : 'ノクターンスカイアイドルシャツS',
            imgUrl      : '/images/items/PAF01-50.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-51',
            rare        : 'PR',
            name        : 'ノクターンスカイアイドルスカートS',
            imgUrl      : '/images/items/PAF01-51.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-52',
            rare        : 'PR',
            name        : 'ノクターンスカイアイドルブーツS',
            imgUrl      : '/images/items/PAF01-52.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-53',
            rare        : 'PR',
            name        : 'ノクターンスカイアイドルヘアアクセS',
            imgUrl      : '/images/items/PAF01-53.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-54',
            rare        : 'PR',
            name        : 'ツインギンガムトップス',
            imgUrl      : '/images/items/PAF01-54.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-58',
            rare        : 'PR',
            name        : 'ツインギンガムスカート',
            imgUrl      : '/images/items/PAF01-58.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-56',
            rare        : 'PR',
            name        : 'ツインギンガムシューズ',
            imgUrl      : '/images/items/PAF01-56.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-57',
            rare        : 'PR',
            name        : 'ツインギンガムヘアアクセ',
            imgUrl      : '/images/items/PAF01-57.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PrismVoiceCh',
            rare        : 'PR',
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-55',
            rare        : 'PR',
            name        : 'ツインギンガムパンツ',
            imgUrl      : '/images/items/PAF01-55.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            rare        : 'PR',
          }),
          item({
            collection  : 'PrismVoiceCh',
            rare        : 'PR',
          }),


          // [NOTE] プリズムボイスチャンネル SR
          // ================================================================================

          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-59',
            rare        : 'SR',
            name        : 'トゥインクルリボンサイリウムワンピ',
            imgUrl      : '/images/items/PAF01-59.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-60',
            rare        : 'SR',
            name        : 'トゥインクルリボンサイリウムシューズ',
            imgUrl      : '/images/items/PAF01-60.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-61',
            rare        : 'SR',
            name        : 'トゥインクルリボンサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF01-61.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-62',
            rare        : 'SR',
            name        : 'キャンディアラモードサイリウムワンピ',
            imgUrl      : '/images/items/PAF01-62.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-63',
            rare        : 'SR',
            name        : 'キャンディアラモードサイリウムシューズ',
            imgUrl      : '/images/items/PAF01-63.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-64',
            rare        : 'SR',
            name        : 'キャンディアラモードサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF01-64.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-65',
            rare        : 'SR',
            name        : 'ホリックトリックサイリウムワンピ',
            imgUrl      : '/images/items/PAF01-65.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-66',
            rare        : 'SR',
            name        : 'ホリックトリックサイリウムシューズ',
            imgUrl      : '/images/items/PAF01-66.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-67',
            rare        : 'SR',
            name        : 'ホリックトリックサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF01-67.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-68',
            rare        : 'SR',
            name        : 'マリオネットミューサイリウムワンピ',
            imgUrl      : '/images/items/PAF01-68.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-69',
            rare        : 'SR',
            name        : 'マリオネットミューサイリウムシューズ',
            imgUrl      : '/images/items/PAF01-69.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-70',
            rare        : 'SR',
            name        : 'マリオネットミューサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF01-70.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-71',
            rare        : 'SR',
            name        : 'ハートフルMMサイリウムワンピ',
            imgUrl      : '/images/items/PAF01-71.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-72',
            rare        : 'SR',
            name        : 'ハートフルMMサイリウムシューズ',
            imgUrl      : '/images/items/PAF01-72.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-73',
            rare        : 'SR',
            name        : 'ハートフルMMサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF01-73.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrismVoiceCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-74',
            rare        : 'SR',
            name        : 'SoLaMi♡SMILEチームサイリウムワンピL',
            imgUrl      : '/images/items/PAF01-74.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-75',
            rare        : 'SR',
            name        : 'SoLaMi♡SMILEチームサイリウムシューズL',
            imgUrl      : '/images/items/PAF01-75.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-76',
            rare        : 'SR',
            name        : 'SoLaMi♡SMILEチームサイリウムヘアアクセL',
            imgUrl      : '/images/items/PAF01-76.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-77',
            rare        : 'SR',
            name        : 'DressingPafeチームサイリウムワンピS',
            imgUrl      : '/images/items/PAF01-77.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-78',
            rare        : 'SR',
            name        : 'DressingPafeチームサイリウムシューズS',
            imgUrl      : '/images/items/PAF01-78.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-79',
            rare        : 'SR',
            name        : 'DressingPafeチームサイリウムヘアアクセS',
            imgUrl      : '/images/items/PAF01-79.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-80',
            rare        : 'SR',
            name        : 'フレッシュマーチングスタージャケット',
            imgUrl      : '/images/items/PAF01-80.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-81',
            rare        : 'SR',
            name        : 'フレッシュマーチングスタースカート',
            imgUrl      : '/images/items/PAF01-81.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-82',
            rare        : 'SR',
            name        : 'フレッシュマーチングスターブーツ',
            imgUrl      : '/images/items/PAF01-82.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-83',
            rare        : 'SR',
            name        : 'フレッシュマーチングスターヘアアクセ',
            imgUrl      : '/images/items/PAF01-83.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-84',
            rare        : 'SR',
            name        : 'パイレーツレディワンピ',
            imgUrl      : '/images/items/SLJ3-44.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-85',
            rare        : 'SR',
            name        : 'パイレーツレディシューズ',
            imgUrl      : '/images/items/SLJ3-45.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            id          : 'PAF01-86',
            rare        : 'SR',
            name        : 'パイレーツレディヘアアクセ',
            imgUrl      : '/images/items/SLJ3-46.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrismVoiceCh',
            rare        : 'SR',
          }),


          // [NOTE] イルミナージュコーデ
          // ================================================================================

          externalItem(itemsPriTama01, 'IR01-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama01, 'IR01-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),



          externalItem(itemsPriTama01, 'IR01-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama02, 'IR02-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama02, 'IR02-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama02, 'IR02-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama03, 'IR03-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama03, 'IR03-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama03, 'IR03-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-10', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-11', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-12', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-13', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-14', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-15', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-16', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-17', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-18', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama05, 'IR05-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama05, 'IR05-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama05, 'IR05-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          // [NOTE] キラッとアイドルチャンネル KR
          // ================================================================================

          externalItem(itemsVol01, 'PCH1-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol02, 'PCH2-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol02, 'PCH2-04', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-05', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-06', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol03, 'PCH3-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol03, 'PCH3-04', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-05', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-06', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol04, 'PCH4-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol05, 'PCH5-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol04, 'PCH4-62', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-63', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-64', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol05, 'PCH5-67', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-68', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-69', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol06, 'PCH6-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          // [NOTE] キラッとアイドルチャンネル PR
          // ================================================================================

          externalItem(itemsVol01, 'PCH1-12', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-13', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-14', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-15', { collection: 'KirattoIdol' }),


          externalItem(itemsVol02, 'PCH2-07', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-11', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-09', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-10', { collection: 'KirattoIdol' }),


          externalItem(itemsVol02, 'PCH2-16', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-17', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-18', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-19', { collection: 'KirattoIdol' }),


          externalItem(itemsVol03, 'PCH3-07', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-08', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-09', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-10', { collection: 'KirattoIdol' }),


          externalItem(itemsVol04, 'PCH4-08', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-09', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-10', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-11', { collection: 'KirattoIdol' }),


          externalItem(itemsVol05, 'PCH5-08', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-09', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-10', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-11', { collection: 'KirattoIdol' }),


          externalItem(itemsVol06, 'PCH6-04', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-05', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-06', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-07', { collection: 'KirattoIdol' }),


          externalItem(itemsVol06, 'PCH6-90', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-91', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-92', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-93', { collection: 'KirattoIdol' }),


          // [NOTE] キラッとアイドルチャンネル SR
          // ================================================================================

          externalItem(itemsVol05, 'SP-013', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'SP-014', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'SP-015', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'SP-016', { collection: 'KirattoIdol' }),



          // [NOTE] プリティーオールフレンズチャンネル
          // ================================================================================

          item({
            collection  : 'PAFCh',
            id          : 'PAF01-87',
            rare        : 'SR',
            name        : 'プリティーオールフレンズあいらトップス',
            imgUrl      : '/images/items/PT4-52.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-88',
            rare        : 'SR',
            name        : 'プリティーオールフレンズあいらスカート',
            imgUrl      : '/images/items/PT4-53.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-89',
            rare        : 'SR',
            name        : 'プリティーオールフレンズあいらシューズ',
            imgUrl      : '/images/items/PT4-54.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-90',
            rare        : 'SR',
            name        : 'プリティーオールフレンズあいらヘアアクセ',
            imgUrl      : '/images/items/PT4-55.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PAFCh',
            id          : 'PAF01-91',
            rare        : 'SR',
            name        : 'プリティーオールフレンズりずむトップス',
            imgUrl      : '/images/items/PAF01-91.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'PS',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-92',
            rare        : 'SR',
            name        : 'プリティーオールフレンズりずむパンツ',
            imgUrl      : '/images/items/PAF01-92.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'PS',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-93',
            rare        : 'SR',
            name        : 'プリティーオールフレンズりずむシューズ',
            imgUrl      : '/images/items/PAF01-93.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-94',
            rare        : 'SR',
            name        : 'プリティーオールフレンズりずむヘアアクセ',
            imgUrl      : '/images/items/PAF01-94.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PS',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PAFCh',
            id          : 'PAF01-95',
            rare        : 'SR',
            name        : 'プリティーオールフレンズみおんトップス',
            imgUrl      : '/images/items/PAF01-95.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-96',
            rare        : 'SR',
            name        : 'プリティーオールフレンズみおんスカート',
            imgUrl      : '/images/items/PAF01-96.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'PS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-97',
            rare        : 'SR',
            name        : 'プリティーオールフレンズみおんシューズ',
            imgUrl      : '/images/items/PAF01-97.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'PS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-98',
            rare        : 'SR',
            name        : 'プリティーオールフレンズみおんヘアアクセ',
            imgUrl      : '/images/items/PAF01-98.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PAFCh',
            id          : 'PAF01-107',
            rare        : 'SR',
            name        : 'プリティーオールフレンズみあトップス',
            imgUrl      : '/images/items/PT4-48.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'PS',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-108',
            rare        : 'SR',
            name        : 'プリティーオールフレンズみあスカート',
            imgUrl      : '/images/items/PT4-49.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'PS',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-109',
            rare        : 'SR',
            name        : 'プリティーオールフレンズみあシューズ',
            imgUrl      : '/images/items/PT4-50.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'PS',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-110',
            rare        : 'SR',
            name        : 'プリティーオールフレンズみあヘアアクセ',
            imgUrl      : '/images/items/PT4-51.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PS',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PAFCh',
            id          : 'PAF01-111',
            rare        : 'SR',
            name        : 'プリティーオールフレンズなるトップス',
            imgUrl      : '/images/items/PT4-56.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'PS',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-112',
            rare        : 'SR',
            name        : 'プリティーオールフレンズなるスカート',
            imgUrl      : '/images/items/PT4-57.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-113',
            rare        : 'SR',
            name        : 'プリティーオールフレンズなるシューズ',
            imgUrl      : '/images/items/PT4-58.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'PS',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-114',
            rare        : 'SR',
            name        : 'プリティーオールフレンズなるヘアアクセ',
            imgUrl      : '/images/items/PT4-59.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'PS',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PAFCh',
            id          : 'PAF01-103',
            rare        : 'SR',
            name        : 'プリティーオールフレンズらぁらトップス',
            imgUrl      : '/images/items/PT3-60.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-104',
            rare        : 'SR',
            name        : 'プリティーオールフレンズらぁらスカート',
            imgUrl      : '/images/items/PT3-61.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-105',
            rare        : 'SR',
            name        : 'プリティーオールフレンズらぁらシューズ',
            imgUrl      : '/images/items/PT3-62.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-106',
            rare        : 'SR',
            name        : 'プリティーオールフレンズらぁらヘアアクセ',
            imgUrl      : '/images/items/PT3-63.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PAFCh',
            id          : 'PAF01-99',
            rare        : 'SR',
            name        : 'プリティーオールフレンズゆいトップス',
            imgUrl      : '/images/items/PT3-56.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-100',
            rare        : 'SR',
            name        : 'プリティーオールフレンズゆいスカート',
            imgUrl      : '/images/items/PT3-57.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'PS',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-101',
            rare        : 'SR',
            name        : 'プリティーオールフレンズゆいシューズ',
            imgUrl      : '/images/items/PT3-58.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PAFCh',
            id          : 'PAF01-102',
            rare        : 'SR',
            name        : 'プリティーオールフレンズゆいヘアアクセ',
            imgUrl      : '/images/items/PT3-59.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PS',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          externalItem(itemsJewel04  , 'PAF-J4-01', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-02', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-03', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-04', { collection: 'PAFCh' }),


          externalItem(itemsJewel04  , 'PAF-J4-05', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-06', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-07', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsJewel04  , 'PAF-J4-08', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-09', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-10', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsJewel05  , 'PAF-J5-01', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-02', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-03', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-04', { collection: 'PAFCh' }),


          externalItem(itemsJewel05  , 'PAF-J5-05', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-06', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-07', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-08', { collection: 'PAFCh' }),


          externalItem(itemsJewel05  , 'PAF-J5-09', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-10', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama01, 'PT1-113', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-114', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-115', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama01, 'PT1-116', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-117', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-118', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama01, 'PT1-119', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-120', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-121', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama02, 'PT2-118', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-119', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-120', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama02, 'PT2-121', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-122', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-123', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama02, 'PT2-124', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-125', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-126', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          // [NOTE] パシャッとアイテムチャンネル
          // ================================================================================

          externalItem(itemsPriTama05, 'PT5-122' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-66' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-67' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-68' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-68' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-69' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-68' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-70' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-15' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-61' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-81' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-20' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-86' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'SL5-98'  , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'SL5-99'  , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-24' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-110', { collection: 'PashaItemCh' }),
          externalItem(itemsJewel01  , 'J1-19'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel01  , 'J1-79'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel02  , 'J2-23'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel02  , 'J2-83'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel03  , 'J3-30'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel03  , 'J3-102'  , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel05  , 'J5-37'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel06  , 'J6-42'   , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama01, 'PT1-46'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama02, 'PT2-44'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama02, 'PB-83'   , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama03, 'PT3-43'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama03, 'PB-91-P' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama04, 'PB-98'   , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PB-123'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-117' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-118' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-119' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-120' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-121' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-44'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama06, 'PB-157'  , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-69' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-70' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-70' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-71' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-72' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-71' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-72' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-73' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-51' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-52' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-52' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-53' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-54' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-63' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-64' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-65' , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel01  , 'J1-30'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel01  , 'J1-87'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel02  , 'J2-38'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel02  , 'J2-39'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel03  , 'J3-52'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel03  , 'J3-53'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'J4-37'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'J4-38'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'J4-118'  , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'J4-119'  , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'PB-24'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel05  , 'J5-56'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel05  , 'J5-57'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel05  , 'PB-42'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel06  , 'PB-61'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel06  , 'PB-62'   , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama01, 'PT1-51'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama01, 'PT1-52'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama01, 'PB-71'   , { collection: 'PashaItemCh' }),


          // [NOTE] ニコチケ PR プリティーコレクションその1
          // ================================================================================

          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-01',
            rare        : 'PR',
            name        : 'フレッシュピンクベアトップ',
            imgUrl      : '/images/items/NC-F1-01.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 1600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-02',
            rare        : 'PR',
            name        : 'フレッシュピンクパニエ',
            imgUrl      : '/images/items/NC-F1-02.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-F1-01',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-03',
            rare        : 'PR',
            name        : 'フレッシュピンクブーツ',
            imgUrl      : '/images/items/NC-F1-03.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-F1-01',
          }),
          item({
            collection  : 'PrettyCollection1',
            rare        : 'PR',
          }),


          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-04',
            rare        : 'PR',
            name        : 'スターシャインベスト',
            imgUrl      : '/images/items/NC-F1-04.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 1600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-05',
            rare        : 'PR',
            name        : 'スターシャインフリルスカート',
            imgUrl      : '/images/items/NC-F1-05.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-F1-04',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-06',
            rare        : 'PR',
            name        : 'パンプキンウィッチパンプス',
            imgUrl      : '/images/items/NC-F1-06.png',
            kind        : 'パンプス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-F1-04',
          }),
          item({
            collection  : 'PrettyCollection1',
            rare        : 'PR',
          }),


          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-07',
            rare        : 'PR',
            name        : 'レッドロックベアトップ',
            imgUrl      : '/images/items/NC-F1-07.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 1600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-08',
            rare        : 'PR',
            name        : 'レッドロックスカート',
            imgUrl      : '/images/items/NC-F1-08.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-F1-07',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-09',
            rare        : 'PR',
            name        : 'レッドロックブーツ',
            imgUrl      : '/images/items/NC-F1-09.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-F1-07',
          }),
          item({
            collection  : 'PrettyCollection1',
            rare        : 'PR',
          }),


          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-10',
            rare        : 'PR',
            name        : 'ホワイトスワントップス',
            imgUrl      : '/images/items/NC-F1-10.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-11',
            rare        : 'PR',
            name        : 'ホワイトスワンパニエ',
            imgUrl      : '/images/items/NC-F1-11.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 850,
            aggregation : 'NC-F1-10',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-12',
            rare        : 'PR',
            name        : 'ホワイトスワンシューズ',
            imgUrl      : '/images/items/NC-F1-12.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 900,
            aggregation : 'NC-F1-10',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-13',
            rare        : 'PR',
            name        : 'ホワイトスワンヘアアクセ',
            imgUrl      : '/images/items/NC-F1-13.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-F1-10',
          }),


          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P1P-08',
            rare        : 'PR',
            name        : 'フラワーショップブルースタートップス',
            imgUrl      : '/images/items/NC-P1P-08.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P1P-09',
            rare        : 'PR',
            name        : 'フラワーショップブルースタースカート',
            imgUrl      : '/images/items/NC-P1P-09.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-P1P-08',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P1P-10',
            rare        : 'PR',
            name        : 'フラワーショップブルースターシューズ',
            imgUrl      : '/images/items/NC-P1P-10.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            aggregation : 'NC-P1P-08',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P1P-11',
            rare        : 'PR',
            name        : 'フラワーショップブルースターヘアアクセ',
            imgUrl      : '/images/items/NC-P1P-11.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            aggregation : 'NC-P1P-08',
          }),


          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P4P-69',
            rare        : 'PR',
            name        : 'ホイップいちごベリートップス',
            imgUrl      : '/images/items/NC-P4P-69.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : '750',
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P4P-70',
            rare        : 'PR',
            name        : 'ホイップいちごベリースカート',
            imgUrl      : '/images/items/NC-P4P-70.png',
            kind        : 'スカート',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : '850',
            aggregation : 'NC-P4P-69',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P4P-71',
            rare        : 'PR',
            name        : 'ホイップいちごベリーシューズ',
            imgUrl      : '/images/items/NC-P4P-71.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : '800',
            aggregation : 'NC-P4P-69',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P4P-72',
            rare        : 'PR',
            name        : 'ホイップいちごベリーヘアアクセ',
            imgUrl      : '/images/items/NC-P4P-72.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : '750',
            aggregation : 'NC-P4P-69',
          }),


          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P6P-08',
            rare        : 'PR',
            name        : 'スクール☆ガールレッドチェックトップス',
            imgUrl      : '/images/items/NC-P6P-08.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P6P-09',
            rare        : 'PR',
            name        : 'スクール☆ガールレッドチェックスカート',
            imgUrl      : '/images/items/NC-P6P-09.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            aggregation : 'NC-P6P-08',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P6P-10',
            rare        : 'PR',
            name        : 'スクール☆ガールレッドチェックシューズ',
            imgUrl      : '/images/items/NC-P6P-10.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            aggregation : 'NC-P6P-08',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P6P-11',
            rare        : 'PR',
            name        : 'スクール☆ガールレッドチェックヘアアクセ',
            imgUrl      : '/images/items/NC-P6P-11.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            aggregation : 'NC-P6P-08',
          }),


          // [NOTE] ニコチケ SR プリティーコレクションその1
          // ================================================================================

          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-14',
            rare        : 'SR',
            name        : 'ベイビーモンスターサイリウムワンピ',
            imgUrl      : '/images/items/NC-F1-14.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-15',
            rare        : 'SR',
            name        : 'ベイビーモンスターサイリウムシューズ',
            imgUrl      : '/images/items/NC-F1-15.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-F1-14',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-16',
            rare        : 'SR',
            name        : 'ベイビーモンスターサイリウムヘアアクセ',
            imgUrl      : '/images/items/NC-F1-16.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-F1-14',
          }),
          item({
            collection  : 'PrettyCollection1',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-17',
            rare        : 'SR',
            name        : 'フォーチュンパーティーサイリウムワンピD',
            imgUrl      : '/images/items/NC-F1-17.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-18',
            rare        : 'SR',
            name        : 'フォーチュンパーティーサイリウムシューズD',
            imgUrl      : '/images/items/NC-F1-18.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-F1-17',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-19',
            rare        : 'SR',
            name        : 'フォーチュンパーティーサイリウムヘアアクセD',
            imgUrl      : '/images/items/NC-F1-19.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-F1-17',
          }),
          item({
            collection  : 'PrettyCollection1',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-20',
            rare        : 'SR',
            name        : 'フォーチュンパーティーサイリウムワンピR',
            imgUrl      : '/images/items/NC-F1-20.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-21',
            rare        : 'SR',
            name        : 'フォーチュンパーティーサイリウムシューズR',
            imgUrl      : '/images/items/NC-F1-21.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-F1-20',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-22',
            rare        : 'SR',
            name        : 'フォーチュンパーティーサイリウムヘアアクセR',
            imgUrl      : '/images/items/NC-F1-22.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-F1-20',
          }),
          item({
            collection  : 'PrettyCollection1',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-23',
            rare        : 'SR',
            name        : 'クリスタルスノープリンセストップス',
            imgUrl      : '/images/items/NC-F1-23.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 750,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-24',
            rare        : 'SR',
            name        : 'クリスタルスノープリンセススカート',
            imgUrl      : '/images/items/NC-F1-24.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 700,
            aggregation : 'NC-F1-23',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-25',
            rare        : 'SR',
            name        : 'クリスタルスノープリンセスブーツ',
            imgUrl      : '/images/items/NC-F1-25.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-F1-23',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-26',
            rare        : 'SR',
            name        : 'クリスタルスノーヘアアクセ',
            imgUrl      : '/images/items/NC-F1-26.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-F1-23',
          }),


          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-27',
            rare        : 'SR',
            name        : 'スターダストブルーグラデワンピ',
            imgUrl      : '/images/items/NC-F1-27.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 1300,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-28',
            rare        : 'SR',
            name        : 'スターダストブルーグラデシューズ',
            imgUrl      : '/images/items/NC-F1-28.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-F1-27',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-F1-29',
            rare        : 'SR',
            name        : 'スターダストブルーグラデヘアアクセ',
            imgUrl      : '/images/items/NC-F1-29.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-F1-27',
          }),
          item({
            collection  : 'PrettyCollection1',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P3P-19',
            rare        : 'SR',
            name        : 'サマーメイドホワイトリーフトップス',
            imgUrl      : '/images/items/NC-P3P-19.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P3P-20',
            rare        : 'SR',
            name        : 'サマーメイドホワイトリーフスカート',
            imgUrl      : '/images/items/NC-P3P-20.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-P3P-19',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P3P-21',
            rare        : 'SR',
            name        : 'サマーメイドホワイトリーフシューズ',
            imgUrl      : '/images/items/NC-P3P-21.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            aggregation : 'NC-P3P-19',
          }),
          item({
            collection  : 'PrettyCollection1',
            id          : 'NC-P3P-22',
            rare        : 'SR',
            name        : 'サマーメイドホワイトリーフヘアアクセ',
            imgUrl      : '/images/items/NC-P3P-22.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            aggregation : 'NC-P3P-19',
          }),


        ]
      }
    },

    computed: {
    },

    methods: {
      collection (collection = '', rare = '') {
        return rare
          ? _.where(this.items, { collection, rare })
          : _.where(this.items, { collection })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[7,8,9]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="プリリズADチャンネル|🥚 ER 🥚" color="#44cd1f" :items="collection('PRADCh', 'ER')" />
      <ItemList title="プリリズADチャンネル|PR ★★★" color="#ffa1bc" :items="collection('PRADCh', 'PR')" />
      <ItemList title="プリリズADチャンネル|SR ★★" color="#00c7da" :items="collection('PRADCh', 'SR')" />
    </template>

    <template #col2>
      <ItemList title="プリリズADチャンネル|R ★" color="#feab0d" :items="collection('PRADCh', 'R')" />
    </template>

    <template #col3>
      <ItemList title="プリズムボイスチャンネル|🥚 ER 🥚" color="#44cd1f" :items="collection('PrismVoiceCh', 'ER')" />
      <ItemList title="プリズムボイスチャンネル|PR ★★★" color="#ffa1bc" :items="collection('PrismVoiceCh', 'PR')" />
    </template>

    <template #col4>
      <ItemList title="プリズムボイスチャンネル|SR ★★" color="#00c7da" :items="collection('PrismVoiceCh', 'SR')" />
    </template>

    <template #col5>
    </template>

    <template #col6>
    </template>

    <template #col7>
      <ItemList title="イルミナージュコーデ|✨ IR ✨" color="#edd50f" :items="collection('ReappearIR') | first(9 * 4)" />
    </template>

    <template #col8>
      <ItemList title="イルミナージュコーデ|✨ IR ✨" color="#edd50f" :items="collection('ReappearIR') | rest(9 * 4)" :isOrphan="true" />
    </template>

    <template #col9>
      <ItemList title="キラッとアイドルCH|KR ★★★★" color="#ff5d91" :items="collection('KirattoIdol', 'KR')" />
    </template>

    <template #col10>
      <ItemList title="キラッとアイドルCH|PR ★★★" color="#ffa1bc" :items="collection('KirattoIdol', 'PR')" />
      <ItemList title="キラッとアイドルCH|SR ★★" color="#00c7da" :items="collection('KirattoIdol', 'SR')" />
    </template>

    <template #col11>
      <ItemList title="プリティーオールフレンズ|チャンネル" color="#feab0d" :items="collection('PAFCh') | first(10 * 4)" />
    </template>

    <template #col12>
      <ItemList title="プリティーオールフレンズ|チャンネル" color="#feab0d" :items="collection('PAFCh') | rest(10 * 4)" :isOrphan="true" />
    </template>

    <template #col13>
    </template>

    <template #col14>
      <ItemList title="パシャッとアイテム|チャンネル" color="#c598ff" :items="collection('PashaItemCh') | first(9 * 4)" />
    </template>

    <template #col15>
      <ItemList title="パシャッとアイテム|チャンネル" color="#c598ff" :items="collection('PashaItemCh') | rest(9 * 4)" :isOrphan="true" />
    </template>

    <template #col16>
      <ItemList title="プリティーコレクション1|ニコチケ PR ★★★" color="#ffa1bc" :items="collection('PrettyCollection1', 'PR')" />
    </template>

    <template #col17>
      <ItemList title="プリティーコレクション1|ニコチケ SR ★★" color="#00c7da" :items="collection('PrettyCollection1', 'SR')" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" />
    </template>

    <template #col18>
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    // left: $size-unit * 100;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
